import React, { useContext, useEffect, useState } from "react";
import "./supportticketlist.css"; // keep your styling consistent
import ProfileHeader from "../../profile/components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ProfileContext } from "../../../context/ProfileContext";
import { SupportTicketGetAPI } from "../api/SupportTicketAPI";
import { errorUI } from "../../../styled/Swal";
import { FaCalendarAlt, FaClock, FaGlobe, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaCheckCircle, FaUserCheck, FaCommentDots } from "react-icons/fa";
import { ArrowLeft } from "lucide-react";

function SupportTicketList() {
  const { openSidebar } = useOutletContext();
  const [ticket,setTicket] = useState([]);
  const {user} = useContext(ProfileContext)
  const [loading, setLoading] = useState(false)
  const [selectedTicket, setSelectedTicket] = useState(null);
  const navigate = useNavigate();
  
  useEffect(()=>{
    if (!user?._id) return;
    const fetch = async()=>{
      setLoading(true);
      try {
        const res = await SupportTicketGetAPI(user?._id);
        if(res?.success){
            setTicket(res?.res?.data?.data || []);
        }
        else{
          errorUI(res?.message)
        }
      } catch (error) {
        errorUI(error?.message)
      } finally {
      setLoading(false);
      }
    }
    fetch();
  },[user])

  const openModal = (ticket) => setSelectedTicket(ticket);
  const closeModal = () => setSelectedTicket(null);

  return (
    <div className="rp-create-leads-page">
      <ProfileHeader onMenuClick={openSidebar} val="Support Tickets List" />
      <div className="rp-support-actions">
          <button onClick={()=>navigate('/supports')}  type="button" className="rp-create-leads-save-btn">
             <ArrowLeft size={16}/> Back
          </button>
        </div>
      <div className="rp-tickets-table-container">
        <table className="rp-tickets-table">
          <thead >
            <tr>
              <th>Title</th>
              <th>Date</th>
              <th>Platform</th>
              <th>Status</th>
              <th>Resolved By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
          {loading ? (
             <tr>
              <td colSpan="6" style={{ padding: 0 }}>
                <div className="rp-tickets-loading">
                  Loading tickets...
                </div>
              </td>
            </tr>
          ) : ticket.length === 0 ? (
            <tr>
              <td colSpan="6">
                <div className="rp-leads-empty">
                  No Support Tickets Found
                </div>
              </td>
            </tr>
          ) : (
            ticket.map((ticket, idx) => (
              <tr key={idx}>
                <td>{ticket.title}</td>
                <td>{ticket.date}</td>
                <td>{ticket.platform}</td>
                <td>{ticket.resolutionSummary.status || 'NA'}</td>
                <td>{ticket.resolutionSummary.resolutionBy || 'NA'}</td>
                <td>
                  <button
                    className="rp-ticket-view-btn"
                    onClick={() => openModal(ticket)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
        </table>
      </div>

      {selectedTicket && (
        <div className="rp-ticket-modal-backdrop">
          <div className="rp-ticket-modal">
            <button className="rp-ticket-modal-close" onClick={closeModal}>
              &times;
            </button>

            {/* Header */}
            <h2>{selectedTicket.title}</h2>
            <p className="modal-subtitle">Requested by: {selectedTicket.requestedBy}</p>

            {/* Info Section with Icons */}
            <div className="modal-info-grid">
              <div><FaCalendarAlt className="modal-icon" /> <strong>Date:</strong> {selectedTicket.date}</div>
              <div><FaClock className="modal-icon" /> <strong>Time:</strong> {selectedTicket.time}</div>
              <div><FaGlobe className="modal-icon" /> <strong>Platform:</strong> {selectedTicket.platform}</div>
              <div><FaMapMarkerAlt className="modal-icon" /> <strong>IP:</strong> {selectedTicket.ip}</div>
              <div><FaPhoneAlt className="modal-icon" /> <strong>Mobile:</strong> {selectedTicket.requesterMobile}</div>
              <div><FaEnvelope className="modal-icon" /> <strong>Email:</strong> {selectedTicket.requesterEmail}</div>
            </div>

            <hr />

            {/* Description */}
            <div className="modal-section">
              <h3>Description</h3>
              <p>{selectedTicket.description}</p>
            </div>

            {/* Resolution Summary */}
            <div className="modal-section resolution-summary">
              <h3>Resolution Summary</h3>
              <div className="modal-info-grid highlight">
                <div><FaCheckCircle className="modal-icon status-icon" /> <strong>Status :</strong>{selectedTicket.resolutionSummary?.status || "-"}</div>
                <div><FaUserCheck className="modal-icon" /> <strong>Resolved By:</strong> {selectedTicket.resolutionSummary?.resolutionBy || "-"}</div>
                <div><FaCalendarAlt className="modal-icon" /> <strong>Resolution DateTime:</strong> {selectedTicket.resolutionSummary?.resolutionDateTime || "-"}</div>
              </div>
              <p><FaCommentDots className="modal-icon" /> <strong>Comments:</strong> {selectedTicket.resolutionSummary?.resolutionComments || "-"}</p>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default SupportTicketList;
